import { FilterAPI } from '@philips-emr/tws-components';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

export default class FilterService {

  static restoreFilterState(event: MountEvent, parameters?: {}): void {
    const api = event.target as FilterAPI;

    const restore = api.restoreState(true);

    if (restore) return;

    const startDate = new Date();
    const endDate = new Date();
    startDate.setMonth(startDate.getMonth() - 3);

    api.setData({
      dtInicio: this.formatDate(startDate),
      dtFim: this.formatDate(endDate),
      ...parameters,
    });

  }

  static persistFilterState(event: MountEvent): void {
    const api = event.target as FilterAPI;
    api.persistState();
  }
  
  private static formatDate(date: Date): string {
    return date.toISOString().slice(0, 10);
  }
}

